import React from "react";

import Button from "../button/Button";
import EBookCover from "./EBookCover";
import logo from "../../images/logo.svg";

function EBook() {
  return (
    <div className="post__injectable">
      <div className="ebook">
        <img className="ebook__logo" src={logo} alt="Accesto" />
        <a
          href="https://accesto.com/books/docker-deep-dive/?utm_source=accesto.com&utm_medium=blog&utm_campaign=ebook&utm_id=ebook"
          target="_blank"
        >
          <EBookCover></EBookCover>
        </a>
        <p className="ebook__text">Docker like a pro!</p>
        <Button
          primary
          href="https://accesto.com/books/docker-deep-dive/?utm_source=accesto.com&utm_medium=blog&utm_campaign=ebook&utm_id=ebook"
        >
          GET FREE EBOOK
        </Button>
      </div>
    </div>
  );
}

export default EBook;
